<app-header *ngIf="userLoggedIn" [userLoggedIn]="userLoggedIn"></app-header>

<div [ngClass]="{'a-main-container': userLoggedIn, 'a-main-container-logout': !userLoggedIn}" class="a-main-container">
    <router-outlet></router-outlet>
</div>

<footer *ngIf="userLoggedIn">
    <!-- <div style="height: 7px;background-color: #253038;"></div>
    <div style="padding: 11px;"></div> -->
    <app-footer></app-footer>
</footer>

<div [ngClass]="{'dvps-loggedin': userLoggedIn, 'dvps-loggedout': !userLoggedIn}">
    <div *ngIf="!isIE"><div class="loader" [hidden]="!showLoader"><div class="loader-content"><p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="5"></p-progressSpinner></div></div></div>
    <div *ngIf="isIE"><div [hidden]="!showLoader" class="loading">Loading&#8230;</div></div>
</div>